import moment from "moment";

/**
 * Format daty z czasem
 */
export const DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
/**
 * Format daty bez czasu
 */
export const DATE_FORMAT = "YYYY-MM-DD";

/**
 * Metoda do formatowania daty z czasem
 * @param date - data do sformatowania
 * @returns date w formacie DATETIME_FORMAT, jesli data jest null, zwraca pusty string
 */
export const formatDateTime = date => {
  if (date) {
    return moment(new Date(date)).format(DATETIME_FORMAT);
  }
  return '';
};

/**
 * Metoda do formatowania daty bez czasu
 * @param date - data do sformatowania
 * @returns date w formacie DATE_FORMAT, jesli data jest null, zwraca pusty string
 */
export const formatDate = date => {
  if (date) {
    return moment(new Date(date)).format(DATE_FORMAT);
  }
  return '';
};

/**
 * Sprawdza czy podana data jest przeterminowana, tzn po dniu aktualnym
 * 
 * @param dateStr - data w stringu
 * 
 * @returns true - jeśli podana data jest po dniu aktualnym, false - jeśli jest wcześniejsza
 */
export const isExpired = dateStr => {
  if (dateStr) {
    //data aktualna
    let now = moment(new Date());
    //data ktora sprawdzamy
    let date = moment(new Date(dateStr))
    //różnica w dniach pomiędzy datami
    let diff = now.diff(date, 'days');
    if (diff > 0) {
      return true;
    }
  }
  return false;
}

/**
 * Metoda do formatowania daty do postaci HH:mm, dla podanego paraemtru sekund
 *
 * @param sourceSec - data do sformatowania, w sekundacg
 */
export const formatSeconds = sec_num => {
  let hours = Math.floor(sec_num / 3600);
  let minutes = Math.floor((sec_num - hours * 3600) / 60);
  let seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  return hours + "h" + minutes + "m";
};

/**
 * Metoda do formatowania Kasiorki PLN
 * 
 * @param amount - kwota do sformatowania
 * @returns kwote w formacie PL
 */
export const formatMoney = amount => {

  /*
  const formatter = new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
  });

  return formatter.format(amount); 
  */

  return amount.toFixed(2).replace('.', ',') + ' zł'
};

/**
 * Metoda do formatowania Kasiorki PLN
 * 
 * @param amount - kwota do sformatowania wybrazona w groszach
 * @returns kwote w formacie PL
 */
export const formatMoneyDiv100 = amount => {

  /*
  const formatter = new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
  });

  return formatter.format(amount); 
  */

  const amountDiv100 = amount / 100;

  return amountDiv100.toFixed(2).replace('.', ',') + ' zł'
};

/**
 * Metoda do parsowanie kwoty w zł do kwoty w groszach
 * 
 * @param amount - kwota do sformatowania wybrazona w zlotowkach
 * @returns kwote w formacie groszowym
 */
export const parseMoneyMultiply100 = amount => {

  /*
  const formatter = new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
  });

  return formatter.format(amount); 
  */

  const amountMultiply100 = amount * 100;

  return Math.floor(amountMultiply100);
};

/**
 * Metoda do parsowanie kwoty w groszach do kwoty w zlotowkach
 * 
 * @param amount - kwota do sformatowania wybrazona w groszach
 * @returns kwote w formacie zlotowkowym
 */
export const parseMoneyDiv100 = amount => {

  /*
  const formatter = new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
  });

  return formatter.format(amount); 
  */

  const amountDiv100 = amount / 100;

  return amountDiv100.toFixed(2);
};

/**
 * Zwraca stringa zawierajacego odpowiadajace nazwy dla obiektu zrodlowego, przedzielonego separatorem ','
 *
 * @param {*} sourceIds zrodlo z tablica z samymi identyfikatorami
 * @param {*} dictionaryObjects slownik z tablica z calymi obiektami, zawierajacymi id  i name
 */
export const arrayIdsToName = (sourceIds, dictionaryObjects) => {
  let result = '';
  sourceIds.forEach(id => {
    let object = dictionaryObjects.find(object => object.id === id);
    if (object !== undefined) {
      //jeśli nie jest puste - doklejamy średnik
      if (result.trim().length !== 0) {
        result += ', ';
      }
      result += object.name;
    }
  });

  return result;
};

/**
 * Zwraca adres w sformatowanej wersji
 * 
 * @param {*} streetName  nazwa ulicy
 * @param {*} streetNumber  numer ulicy
 * @param {*} localNumber numer lokalu
 * @param {*} city miasto
 * @param {*} postCode  kod pocztowy
 */
export const formatAddress = (streetName, streetNumber, localNumber, city, postCode) => {
  let result = "";

  result = result + postCode + " " + city;

  //dodanie separatora po mieście
  let addSeparator = city.length > 0 || postCode.length;
  if (addSeparator) {
    result = result + ", ";
  }

  //dodanie ulicy
  result = result + streetName + " " + streetNumber;

  //dodanie lokalu
  let addLocal = localNumber.length > 0;

  if (addLocal) {
    result = result + "/" + localNumber;
  }

  return result;

}

/**
 * Generuje przykładowe hasło długosci 8 znaków
 */
export const generatePassword = () => {
  let result = Math.random().toString(36).substr(2, 8);
  return result;
}


/**
 * Konwertuje podany string do tablicy integerów
 * 
 * @param {String} string ciag znaków zawierający liczby przedzielone separatorem
 * @param {String} separator  separator oddzielający liczby
 */
export function toIntArray(string, separator) {

  //jeśli argument jest niezdefiniwoany - zwracamy pustą tablicę
  if (!string) {
    return [];
  }

  //jeśli argument nie zawiera separatora - ma tylko jeden element
  if (!string.includes(separator)) {
    let number = toNumber(string);
    if (number != null) {
      //zwracamy tablice z jednym elementem
      return [number]
    } else {
      return []
    }
  }

  let elements = string.split(separator).map(item => toNumber(item)).filter(item => toNumber(item) != null);

  return elements;
}

/**
 * Konwertuje podany ciąg znaków do liczby
 * 
 * @param {String} string 
 * @returns int jeśli podany string jest liczbą lub null jeśli nie jest
 */
function toNumber(string) {

  let integer = parseInt(string); //parseInt nie zwraca błedu dla wartości 1d

  //float
  let number = Number(string); //Number - zwraca float i dla pustego stringa jest 0

  if (!isNaN(integer) && isFinite(integer) && Number.isInteger(number)) {
    return integer;
  }

  return null;
}

/**
 * Konwersja tablicy do mapy, gdzie kluczem jest wartosc obiektu o danej właściwości objectKey, a wartoscia tablica obiektów o pasujacym kluczu
 * 
 * @param {*} array tablica obiektów
 * @param {*} objectKey właświość obiektu po której grupujemy obiekty
 */
export const convertArrayToMap = (array, objectKey) => {

  const map = new Map();

  if (array && array.length > 0) {
    //iterujemy przez kazdy element tablicy
    array.forEach(object => {

      //klucz mapy
      let key = object[objectKey];

      //obiekt moze nie miec właściwości objectKey
      if (key !== undefined) {
        if (!map.has(key)) {
          //inicjalizacja wartości pustą tablicą
          map.set(key, []);
        }
        //dodanie elementu do naszej istniejącej tablicy
        map.get(key).push(object);

      } else {
        console.warn('Object does not contain property: ' + objectKey)
      }

    })
  }

  return map;

}

export function isValidNip(nip) {
  if (typeof nip !== 'string')
    return false;

  nip = nip.replace(/[\s-]/gi, '');

  let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  let sum = 0;
  let controlNumber = parseInt(nip.substring(9, 10));
  let weightCount = weight.length;
  for (let i = 0; i < weightCount; i++) {
    sum += (parseInt(nip.substr(i, 1)) * weight[i]);
  }

  return sum % 11 === controlNumber;
}

export function isValidPesel(pesel) {
  let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  let sum = 0;
  let controlNumber = parseInt(pesel.substring(10, 11));
  for (let i = 0; i < weight.length; i++) {
    sum += (parseInt(pesel.substring(i, i + 1)) * weight[i]);
  }
  sum = sum % 10;
  return 10 - sum === controlNumber;
}

export function isValidEmail(email) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true;
  }
  return false;
}

/**
 * Sprawdza ilosc liczb w podanych ciagu 
 * 
 * @param {*} string 
 * @param {*} digitCount 
 */
export function isValidDigitCount(string, digitCount) {
  if (typeof string !== 'string')
    return false;

  string = string.replace(/[\s-]/gi, '');

  return string.length === digitCount;
}